import AllowedDocument from "models/documents/allowed-document";
import { ScannerType } from "models/scanner-type";

// Pure-data scanner capabilities, kept free of any scanner SDK imports so the
// runtime selection layer (camera probe, navigation gate) can look them up for
// any scanner without pulling a heavy SDK into the bundle.

interface ScannerCapability {
  // [isLowResCheckSupported, minHeight]: whether a pre-scan camera resolution
  // probe applies, and the minimum acceptable height.
  lowResCheck: [boolean, number | undefined];
}

const capabilities: Record<ScannerType, ScannerCapability> = {
  [ScannerType.REGULA]: { lowResCheck: [false, undefined] },
  [ScannerType.MICROBLINK_NEW]: { lowResCheck: [true, 1080] },
  [ScannerType.MICROBLINK_BLINKID]: { lowResCheck: [true, 1080] },
  [ScannerType.INCODE]: { lowResCheck: [false, undefined] },
};

export const isLowResCheckSupported = (
  type: ScannerType
): [boolean, number | undefined] => {
  return capabilities[type]?.lowResCheck ?? [false, undefined];
};

// Every current scanner can cover an allowed-documents set with a single
// instance (the legacy multi-instance Microblink scanner that needed per-doc
// instances is gone), so this is scanner-agnostic. Kept as a function so the
// navigation gate's call site and intent are preserved if a future scanner
// needs per-document instances again.
export const canUseSingleScannerInstance = (
  _docs: AllowedDocument[]
): boolean => {
  return true;
};
